import async from '../components/Async';

// auth pages
const Login = async(() => import('../pages/auth/Login'));
const ForgotPassword = async(() => import('../pages/auth/ForgotPassword'));
const OneLoginCallback = async(() => import('../pages/auth/OneLoginCallback'));

// transcripts pages
const Transcripts = async(() => import('../pages/transcripts'));
const Transcript = async(() => import('../pages/transcripts/TranscriptDetailPage'));

// analytics pages
const Analytics = async(() => import('../pages/analytics'));

// files pages
const Files = async(() => import('../pages/files'));

// trash pages
const Trash = async(() => import('../pages/trash'));

// auth routes
const AuthRoutes = {
  name: 'Auth',
  path: '/auth',
  children: [
    {
      path: '/auth/login',
      component: Login,
    },
    {
      path: '/auth/forgot-password',
      component: ForgotPassword,
    },
    {
      path: '/sso/callback',
      component: OneLoginCallback
    }
  ],
};

// transcripts routes
const TranscriptsRoutes = {
  name: 'Audio Transcripts',
  path: '/transcripts',
  icon: 'audio_transcripts',
  containsHome: true,
  children: [
    {
      path: '/',
      component: Transcripts,
    },
    {
      path: '/transcripts',
      component: Transcripts,
    },
    {
      path: '/transcripts/:id',
      component: Transcript
    }
  ],
};

// analytics routes
const AnalyticsRoutes = {
  name: 'Analytics',
  path: '/analytics',
  icon: 'analytics',
  isNew: true,
  children: [
    {
      path: '/analytics',
      component: Analytics,
    }
  ],
};

// trash routes
const TrashRoutes = {
  name: 'Bin',
  path: '/bin',
  icon: 'remove',
  children: [
    {
      path: '/bin',
      component: Trash
    }
  ]
};

// files routes
const FilesRoutes = {
  name: 'File Management',
  path: '/files',
  icon: 'file',
  children: [
    {
      path: '/files',
      component: Files
    }
  ]
};

export const Auth = [
  AuthRoutes,
];

export const DashboardRoutes = [
  TranscriptsRoutes,
  FilesRoutes,
  AnalyticsRoutes,
  TrashRoutes
];
